export const footerBrandName: string = 'LVBET.LV';
